import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { isNumber } from "lodash";
import { MessageSquare } from "lucide-react";

import { useChat } from "features/Communication/Chat/contexts/ChatContext";
import { useUser } from "utils/hooks/user";
import { cn } from "lib/utils";

function Messages() {
    const user = useUser();
    const { groupConversations, privateConversations } = useChat();

    const unreadConversationCount = useMemo(() => {
        const privateUnreadCount = privateConversations?.filter(({ unreadCount }) => {
            const count = unreadCount[user?.id];
            return isNumber(count) && count > 0;
        }).length || 0;

        const groupUnreadCount = groupConversations?.filter(({ unreadCount }) => {
            const count = unreadCount[user?.id];
            return isNumber(count) && count > 0;
        }).length || 0;

        return privateUnreadCount + groupUnreadCount;
    }, [privateConversations, groupConversations, user?.id]);

    useEffect(() => {
        document.title = unreadConversationCount > 0 ? `(${unreadConversationCount}) Simplitime` : "Simplitime";
    }, [unreadConversationCount]);

    return (
        <Link
            to="/communication/messages"
            className={cn(
                "tw-relative tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-md tw-text-inherit tw-opacity-75 hover:tw-opacity-100"
            )}
        >
            <MessageSquare className="tw-size-5" />
            {unreadConversationCount > 0 && (
                <span className="tw-absolute tw-top-0 tw-right-0 tw-flex tw-h-4 tw-min-w-4 tw-items-center tw-justify-center tw-rounded-full tw-bg-destructive tw-px-1 tw-text-[10px] tw-font-semibold tw-text-destructive-foreground">
                    {unreadConversationCount}
                </span>
            )}
        </Link>
    );
}

export default Messages;
